// src/pages/HomePage.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import './HomePage.css';

import HeroSection from '../components/home/HeroSection';
import HomeHeroSlider from '../components/home/HomeHeroSlider';
import HomeCmsSections from '../components/home/HomeCmsSections';
import ServicesOverviewSection from '../components/home/ServicesOverviewSection'; // Gardé, même s'il n'est pas utilisé dans ta structure actuelle
import PortfolioHighlightSection from '../components/home/PortfolioHighlightSection';
import TechStackSection from '../components/home/TechStackSection';
import TestimonialsSection from '../components/home/TestimonialsSection';
import FinalCTASection from '../components/home/FinalCTASection';
import KeyBenefitsSnippet from '../components/home/KeyBenefitsSnippet'; // Gardé, même s'il n'est pas utilisé dans ta structure actuelle
import HomePricingSection from '../components/home/HomePricingSection';
import HomeValuePropositionSection from '../components/home/HomeValuePropositionSection'; // NOUVEL IMPORT

function HomePage() {
  const navigate = useNavigate();
  const siteUrl = "https://www.infocolab.com"; // Mettez votre domaine réel

  return (
    <>
      <Helmet>
        <title>INFO COLAB - Agence Web Créative et Développement Full-Stack à Lombez, Occitanie</title>
        <meta name="description" content="INFO COLAB, agence web à Lombez (Gers, 32). Création de sites internet, applications web, design UX/UI, et solutions full-stack innovantes." />
        <link rel="canonical" href={siteUrl} />
        <meta property="og:title" content="INFO COLAB - Agence Web Créative et Développement Full-Stack" />
        <meta property="og:description" content="Solutions web sur mesure, design UX/UI, et développement innovant à Lombez, Occitanie." />
        <meta property="og:image" content={`${siteUrl}/images/og-image-accueil.jpg`} /> {/* Assurez-vous que cette image existe */}
        <meta property="og:url" content={siteUrl} />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="INFO COLAB" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="INFO COLAB - Agence Web Créative et Développement Full-Stack" />
        <meta name="twitter:description" content="Solutions web sur mesure, design UX/UI, et développement innovant à Lombez, Occitanie." />
        <meta name="twitter:image" content={`${siteUrl}/images/og-image-accueil.jpg`} /> {/* Assurez-vous que cette image existe */}
      </Helmet>

      <div className="container">
        <HomeHeroSlider />
        <HomeCmsSections />
        <HeroSection />
        <PortfolioHighlightSection />
      </div>


      <HomePricingSection />

      <div className="container">
        <TechStackSection />
      </div>

      <div className="container">
        <FinalCTASection />

        {/* Nouvelle section des propositions de valeur pour la page d'accueil */}
        <HomeValuePropositionSection />

        <div style={{ marginTop: 80, marginBottom: 80, padding: '0 20px' }}>
          <div className="card" style={{ maxWidth: 800, margin: '0 auto', border: '1px solid #3b82f6', borderRadius: 10, padding: 30, background: 'linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)', color: 'white', textAlign: 'center' }}>
            <h3 style={{ marginTop: 0, color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 12, fontSize: '1.5rem' }}>
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /></svg>
              Rejoindre l'équipe
            </h3>
            <p style={{ color: 'rgba(255,255,255,0.9)', fontSize: '1.1rem', margin: '16px auto', maxWidth: 600 }}>
              Vous souhaitez aller plus loin et devenir partenaire ? Postulez en quelques clics via votre compte existant.
            </p>
            <div style={{ display: 'flex', gap: 16, marginTop: 24, justifyContent: 'center', flexWrap: 'wrap' }}>
              <button className="btn" style={{ border: 'none', background: 'white', color: '#1e40af', fontWeight: 600, padding: '12px 24px', fontSize: '1rem', cursor: 'pointer', borderRadius: '8px' }} onClick={() => navigate('/candidature', { state: { role: 'commercial', skipIntro: true } })}>
                Devenir Commercial
              </button>
              <button className="btn" style={{ background: 'rgba(255,255,255,0.2)', color: 'white', border: '1px solid rgba(255,255,255,0.4)', padding: '12px 24px', fontSize: '1rem', cursor: 'pointer', borderRadius: '8px' }} onClick={() => navigate('/candidature', { state: { role: 'developpeur', skipIntro: true } })}>
                Devenir Développeur
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default HomePage;